import {z} from 'zod';

export const customClosingDayFormSchema = z.object({
  date: z.date(),
  name: z.string().min(1),
  branchIds: z.array(z.string()).nullable(),
  recurring: z.boolean(),
});

export type CustomClosingDayFormValues = z.infer<typeof customClosingDayFormSchema>;

export const updatePublicClosingDaySchema = z.object({
  branchIds: z.array(z.string()).nullable(),
  enabled: z.boolean(),
});

export type UpdatePublicClosingDayFormValues = z.infer<typeof updatePublicClosingDaySchema>;
